import { map } from 'lodash';

class PeriodsListController {

  constructor($scope, $state, periodsService, messageService, access) {
    this.$scope = $scope;
    this.$state = $state;
    this.periodsService = periodsService;
    this.messageService = messageService;
    this.access = access;
  }

  $onInit() {
    this.updatePaging();
    this.$scope.$watch(
      function (scope) {
        return scope.current_page;
      },
      function (newVal, oldVal, scope) {
        if (newVal !== oldVal){
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered){
            scope.$ctrl.periods = undefined;
            scope.$ctrl.periodsService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
              scope.$ctrl.periods = response;
              scope.$ctrl.loading = false;
            });
          }
          else{
            scope.$ctrl.periodsService.findAll(newVal, scope.per_page)
              .then(list => scope.$ctrl.periods = list);
          }
        }
      }
    );
    this.dragControlListeners = {
      accept: function (sourceItemHandleScope, destSortableScope) {return true;},
      containment: '#list',
      containerPositioning: 'relative',
      orderChanged: function(event){
        event.source.sortableScope.$parent.$parent.$ctrl.savePosition();
      }
    };
  }

  updatePaging(){
    this.$scope.per_page = this.periods.per_page;
    this.$scope.current_page = this.periods.current_page;
    this.$scope.total = this.periods.total;
  }

  onDelete(period) {
    this.periodsService.delete(period.id)
      .then(() => {
        this.messageService.success(`The period <strong>${period.name}</strong> was successfully deleted.`);
        this.messageService.push();
      })
      .catch((error) => {
        this.messageService.failure(`The period <strong>${period.name}</strong> could not be successfully deleted: ${error.statusText}`);
        this.messageService.push();
      })
      .then(() => {
        let page = this.periods.current_page;
        this.periods = [];
        this.loading = true;
        return this.periodsService.findAll(page).then(response => {
            this.periods = response;
            this.loading = false;
        });
      });
  }

  filter(){
    if (!this.loading && this.filtertext){
      this.isFiltered = true;
      this.periods = undefined;
      this.loading = true;
      this.periodsService.search(this.filtertype, this.filtertext).then(response => {
        this.periods = response;
        this.updatePaging();
        this.loading = false;
      });
    }
  }

  clearfilter(){
    if (this.isFiltered) {
      this.isFiltered = false;
      this.periods = undefined;
      this.loading = true;
      this.periodsService.findAll(-1).then(response => {
        this.periods = response;
        this.$scope.current_page = 1;
        this.$scope.total = response.total;
        this.loading = false;
      });
    }
  }

  filtertypeChange() {
    switch(this.filtertype) {
      case 'cat':
        this.filtertext = this.categories.flat[0].id;
        break;
      case 'status':
        this.filtertext = '1';
        break;
      default:
        this.filtertext = '';
        break;
    }
  }

  savePosition(){
    var periods = '';

    for (var i = 0; i<this.periods.length; i++){
      periods += this.periods[i].id;
      if (i+1 !== this.periods.length){
        periods += ',';
      }
    }
    this.periodsService.updateList(periods).then(() => {
      this.messageService.success('The period priority order has been successfully updated');
      this.messageService.push();
      this.messageService.autoClear();
    })
    .catch((error) => {
      this.messageService.failure(`The period priority order could not be successfully updated: ${error.statusText}`);
      this.messageService.push();
      this.messageService.autoClear();
    });
  }
}

PeriodsListController.$inject = [ '$scope', '$state', 'periodsService', 'messageService', 'access' ];

export default PeriodsListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/controllers/periods.list.controller.js